import { plainToInstance, Type } from 'class-transformer';
import { isFuture } from 'date-fns';
import { Inspection } from './Inspection';
import { Material } from './inventory';
import { ServiceLineSide } from './ServiceLine';

export interface ServiceLineMaterial {
  id: string;
  endOn: string;
  beginOn: string;
  material: Material;
  method: Method;
  source: string;
  isInspectionRequired: boolean;
  inspections: Inspection[];
  serviceSide: ServiceLineSide;
}

export class ServiceLineMaterial {
  @Type(() => Material)
  material: Material;

  get isActive(): boolean {
    return !this.endOn || isFuture(new Date(this.endOn));
  }

  get isUnknown() {
    return !this.material || this.material.isUnknown;
  }

  get copy() {
    return plainToInstance(ServiceLineMaterial, this);
  }
}

interface Method {
  id: string;
  code: string;
  description: string;
}
